/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

import EmblaCarousel, {
  EmblaCarouselType,
  EmblaOptionsType,
} from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

export function initContentSlider(): void {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  )
  const contentSliders = Array.from(
    document.querySelectorAll('.content-slider'),
  ) as HTMLElement[]

  for (const contentSlider of contentSliders) {
    if (contentSlider.dataset.hydrated) continue
    contentSlider.dataset.hydrated = 'true'
    const prev = contentSlider.querySelector(
      '.content-slider__controls-nav-arrow--prev',
    ) as HTMLElement | null
    const next = contentSlider.querySelector(
      '.content-slider__controls-nav-arrow--next',
    ) as HTMLElement | null
    const track = contentSlider.querySelector(
      '.content-slider__list-track',
    ) as HTMLElement | null
    const list = contentSlider.querySelector(
      '.content-slider__list',
    ) as HTMLElement | null
    const count = contentSlider.querySelector(
      '.content-slider__controls-count-current',
    ) as HTMLElement | null
    const countTotal = contentSlider.querySelector(
      '.content-slider__controls-count-total',
    ) as HTMLElement | null

    if (!prev || !next || !track || !count || !countTotal || !list) {
      continue
    }

    const options: EmblaOptionsType = {
      slidesToScroll: 1,
      loop: false,
      align: 'start',
      containScroll: false,
    }

    const animationOptions = () => {
      return prefersReducedMotion.matches ? { duration: 0 } : { duration: 25 }
    }

    const emblaApi = EmblaCarousel(track, {
      ...options,
      ...animationOptions(),
    }, [WheelGesturesPlugin()])

    prefersReducedMotion.addEventListener('change', () => {
      emblaApi.reInit({
        ...options,
        ...animationOptions(),
      })
    })

    prev.addEventListener('click', () => emblaApi.scrollPrev(), false)
    next.addEventListener('click', () => emblaApi.scrollNext(), false)

    const handleSelect = () => {
      const setButtonState = (button: HTMLElement, enabled: boolean) => {
        button.toggleAttribute('disabled', !enabled)
      }
      setButtonState(prev, emblaApi.canScrollPrev())
      setButtonState(next, emblaApi.canScrollNext())

      count.innerText = (emblaApi.selectedScrollSnap() + 1).toString().padStart(
        2,
        '0',
      )
    }

    handleSelect()

    emblaApi.on('select', handleSelect)

    countTotal.innerText = list.childElementCount.toString().padStart(2, '0')
  }
}
